<template>
  <div id="app">
    <router-view v-if="isRouter" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouter: true
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      this.isRouter = false;
      this.$nextTick(function() {
        this.isRouter = true;
      });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
a {
  color: #333;
  text-decoration: none;
}
#app {
  background: #f7f8fa;
}
.anchorBL {
  display: none;
}
.content img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}
.abountUs .is-disabled .titleName  {
    color: #0f1f78 !important;
}
.talentTeamList .el-collapse-item__header {
  background-color: #f8f8f8;
  height: 102px;
  line-height: 102px;
  padding-left: 94px;
  padding-right: 47px;
  font-size: 20px;
  color: #0f1f78;
}

.talentTeamList .el-collapse-item__wrap {
  padding: 0 86px;
  padding-top: 30px;
  font-size: 16px;
  color: #333;
}
.talentTeamList .el-icon-arrow-right::before {
  content: "";
}
.talentTeamList .el-collapse-item__arrow {
  width: 30px;
  height: 30px;
  background: url("../src/assets/images/teamIcon1.png") 100% 100% no-repeat;
  background-size: cover;
}
.recruitment_m .el-collapse-item__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.2rem !important;
  line-height: 1.2rem !important;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
}
.recruitment_m .is-active .el-collapse-item__wrap {
  padding-top: 0.47rem;
  box-sizing: border-box;
}
.recruitment .is-active .el-collapse-item__wrap {
  padding-top: 20px;
  box-sizing: border-box;
}
.el-collapse-item__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 86px !important;
  line-height: 86px !important;
  padding-left: 70px;
  padding-right: 56px;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
}
.social .el-collapse-item__arrow {
  display: none !important;
}
.el-collapse-item__header.is-active {
  border-bottom-color: #e3e3e3;
}

.pageSize {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.el-pagination.is-background .el-pager .active {
  background-color: #0f1f78 !important;
}
.el-dialog {
  min-width: 1200px;
}
.recruitment_m .el-dialog {
  max-width: 100%;
  min-width: 6.9rem;
}
.partnerList .swiper-wrapper {
  transition-timing-function: linear !important;
}
.menuLeft {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translate(0, -10%);
  width: 100px;
  box-sizing: border-box;
  padding: 0px 15px;
  height: 200px;
  z-index: 1000;
  background-color: #0f1f78;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.menuLeft::after {
  position: absolute;
  display: block;
  width: 60px;
  content: "";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 1px;
  background-color: #fff;
  opacity: 0.3;
}
.menuLeft .menuItem {
  cursor: pointer;
  display: block;
  width: 100%;
  color: #fff;
  /* height: 170px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.menuLeft .menuItem img {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
}
.menuLeft_m {
  position: fixed;
  right: 0;
  top: 50%;
transform: translate(0, 150%);
  width: .8rem;
  box-sizing: border-box;
  padding: 0px .15rem;
  height: 1.5rem;
  z-index: 1000;
  background-color: #0f1f78;
  font-size: .20rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.menuLeft_m.contactUs_m{
    height: auto;
}
.menuLeft_m.contactUs_m::after{
    display: none;
}
.menuLeft_m.contactUs_m .menuItem{
    padding: .2rem 0;
}
.menuLeft_m::after {
  position: absolute;
  display: block;
  width: .8rem;
  content: "";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 1px;
  background-color: #fff;
  opacity: 0.3;
}
.menuLeft_m .menuItem {
  cursor: pointer;
  display: block;
  width: 100%;
  color: #fff;
  /* height: 170px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.menuLeft_m .menuItem img {
  width: .40rem;
  height: .40rem;
  margin-bottom: .10rem;
}

/* 移动端样式 */
.two_nav_m .swiper-button-prev,
.two_nav_m .swiper-button-next {
  width: 0.2rem;
  height: 0.38rem;
  margin: 0;
  top: 0.2rem;
}
.two_nav_m .swiper-button-prev {
  left: -0.44rem;
  background-image: url("../src/assets/images/fleid_zuo.png");
  background-position: center;
  background-size: contain;
}
.two_nav_m .swiper-button-next {
  right: -0.44rem;
  background-image: url("../src/assets/images/fleid_you.png");
  background-position: center;
  background-size: contain;
}
/* 二级页面导航栏 H5 */
.two_nav_m {
  margin: 0 0.75rem;
  position: relative;
  height: 0.82rem;
  border-bottom: 0.01rem solid #ededed;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  font-size: 0.26rem;
}
.two_nav_m .swiper-container {
  width: 100%;
}
.two_nav_m .two_nav_title {
  /* position: relative;
    top: 0rem; */
  min-width: 1.6rem;
  padding: 0 0.1rem;
  height: 0.82rem;
  line-height: 0.82rem;
  background: #0f1f78;
  text-align: center;
  font-size: 0.24rem;
  color: #f8f8f8;
}
.two_nav_m .swiper-slide {
  width: auto;
  padding: 0 0.1rem;
}
.two_nav_m .towNavItem {
  display: block;
  height: 0.82rem;
  line-height: 0.82rem;
  font-size: 0.3rem;
  color: #333;
  text-align: center;
  cursor: pointer;
  padding: 0 0.3rem;
}
.two_nav_m .router-link-active {
  display: inline-block;
  height: 0.82rem;
  line-height: 0.82rem;
  color: #0f1f78;
  /* background-color: #0f1f78; */
}
.two_nav_m .router-link-active span {
  color: #fff;
  /* border-bottom: 0.01rem solid #a9171f; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue